/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCopy} from '../api'

 export const useQueryGetCopy = createReactQueryHook('getCopy', getCopy)
